namespace GeniuzPOS.ReportMasterData {
    export class Report_1337Columns {
        static columnsKey = 'ReportMasterData.Report_1337';
    }
}
